import Phaser from 'phaser';

import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { BlocksMainScene } from '../../scenes/blocks-main-scene';
//import { DebugContainerVisual } from '../debug/debug-container-visual';
import { Subscription } from 'rxjs';
import { LoadingCellViewModel } from './loading-cell-view-model';
import { delay } from 'src/games/common/helper';

export class LoadingCellView extends Phaser.GameObjects.Container {
  public get row() {
    return this.viewModel.row;
  }
  public get column() {
    return this.viewModel.column;
  }
  private cellRectangle: Phaser.GameObjects.Rectangle;
  private fadeAnimation: Phaser.Tweens.Tween;

  private subscriptionGroup: Subscription;
  //private debugContainerVisual: DebugContainerVisual;

  constructor(
    scene: BlocksMainScene,
    x: number,
    y: number,
    private viewModel: LoadingCellViewModel,
  ) {
    super(scene, x, y);

    //this.debugContainerVisual = new DebugContainerVisual(scene, this);

    this.subscriptionGroup = new Subscription();

    this.cellRectangle = scene.add
      .rectangle(0, 0, 0, 0, viewModel.cellColor)
      .setAlpha(viewModel.cellAlpha);
    this.add([this.cellRectangle]);

    this.setName(LoadingCellView.name);
    scene.add.existing(this);

    this.fadeAnimation = scene.tweens.add({
      targets: this,
      alpha: { from: 0.0, to: 0.4 },
      duration: 1000,
      ease: 'Quad.InOut',
      paused: true,
      repeat: -1,
      yoyo: true,
      onComplete: () => {
        this.alpha = 1;
      },
    });
    this.alpha = 0;
  }

  override destroy(fromScene?: boolean | undefined): void {
    this.subscriptionGroup.unsubscribe();

    super.destroy(fromScene);
  }

  public onResize(gameSizeMetrics: GameSizeMetrics) {
    const layoutConfig = this.viewModel.layoutConfig;
    const calc = this.viewModel.calculateScaleFactor(gameSizeMetrics);

    const cellSz = (layoutConfig.boardWidth - layoutConfig.cellBorder) / 9;
    const innerCellSz = cellSz - layoutConfig.cellBorder;
    const scaledCellSz = innerCellSz * calc.scaleFactor;

    const row = 1 + this.viewModel.row;
    const column = 1 + this.viewModel.column;

    const xPos = (innerCellSz + layoutConfig.cellBorder) * column - innerCellSz * 0.5;
    const yPos = (innerCellSz + layoutConfig.cellBorder) * row - innerCellSz * 0.5;

    this.setPosition(
      (layoutConfig.hMargin + xPos) * calc.scaleFactor + calc.scaledOffsetX,
      (layoutConfig.vMargin + yPos) * calc.scaleFactor,
    );
    this.setSize(scaledCellSz, scaledCellSz);

    this.cellRectangle.setSize(scaledCellSz, scaledCellSz);
  }

  public async animateIn(delayMs: number): Promise<void> {
    await delay(delayMs);
    this.fadeAnimation.play();
  }
}
